import { TranslationString } from 'shared/entities/localization';
import {
  EmailDomainPolicyError,
  mapEmailDomainPolicyErrorToMessage
} from 'shared/entities/emailDomainPolicy';

import { Permission } from '../permissions';
import { ManagerExternalsServer } from '../user';

export enum AcceptInvitationErrorCode {
  managerAlreadyAdd = 'manager_already_exists',
  tokenExpired = 'expired_token',
  managerNotFound = 'manager_not_found',
  invalidToken = 'invalid_token'
}

export const mapAcceptInvitationErrorCodeToMessage =
  (code: AcceptInvitationErrorCode): TranslationString =>
  (t) =>
    t(`manager.acceptInvitationErrors.${code}`, {
      ns: 'entities'
    });

export enum CabinetManagerRoleType {
  owner = 'owner',
  admin = 'admin',
  operator = 'operator',
  moderator = 'moderator',
  spectator = 'spectator',
  billing = 'billing',
  guest = 'guest'
}

export enum ProjectManagerRoleType {
  admin = 'admin',
  ro = 'ro'
}

export type ManagerBaseServer = {
  _id: string;
  name: string;
  email: string;
};

export type ProjectManagerEntityServer = {
  _id: string;
  name: string;
  role: ProjectManagerRoleType;
};

export type CabinetManagerServer = ManagerBaseServer & {
  cabinet_role: CabinetManagerRoleType | null;
  projects: ProjectManagerEntityServer[];
  is_role_changeable: boolean;
  external_ids: ManagerExternalsServer;
};

export type ProjectManagerServer = ManagerBaseServer & {
  project_role: ProjectManagerRoleType | null;
  is_role_changeable: boolean;
};

/** managers/list_mentionable: только менеджеры проекта с ролью admin или ro. */
export type MentionableManagerServer = {
  _id: string;
  /** Может быть неуникальным и не заполненным */
  name: string | null;
  email: string;
  project_role: ProjectManagerRoleType;
};

export type ManagerRoleEntity<R> = {
  role: R;
  permissions: Permission[];
};

export type CabinetManagerRoleEntity =
  ManagerRoleEntity<CabinetManagerRoleType>;
export type ProjectManagerRoleEntity =
  ManagerRoleEntity<ProjectManagerRoleType>;

export enum ProjectManagerAddingErrorCode {
  managerAlreadyExists = 'manager_already_exists'
}

export type ProjectManagerAddingResponseErrorCode =
  | ProjectManagerAddingErrorCode
  | EmailDomainPolicyError.REGISTRATION_EMAIL_DOMAIN_NOT_ALLOWED;

export const mapProjectManagerAddingErrorCodeToMessage = (
  code: ProjectManagerAddingResponseErrorCode
): TranslationString => {
  if (code === EmailDomainPolicyError.REGISTRATION_EMAIL_DOMAIN_NOT_ALLOWED) {
    return mapEmailDomainPolicyErrorToMessage(code);
  }

  return (t) =>
    t(`manager.addingErrors.${code}`, {
      ns: 'entities'
    });
};

export enum ManagerRemovingErrorCode {
  managerSelfEdit = 'manager_self_edit'
}

export const mapManagerRemovingErrorCodeToMessage =
  (code: ManagerRemovingErrorCode): TranslationString =>
  (t) =>
    t(`manager.removingErrors.${code}`, {
      ns: 'entities'
    });
